module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/36377.1b00dd14.jpg";